import { render, staticRenderFns } from "./SensorIcon.vue?vue&type=template&id=40bfd003&scoped=true&"
import script from "./SensorIcon.vue?vue&type=script&lang=js&"
export * from "./SensorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bfd003",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bfd003')) {
      api.createRecord('40bfd003', component.options)
    } else {
      api.reload('40bfd003', component.options)
    }
    module.hot.accept("./SensorIcon.vue?vue&type=template&id=40bfd003&scoped=true&", function () {
      api.rerender('40bfd003', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SensorIcon.vue"
export default component.exports